import { render, staticRenderFns } from "./btn-renderer.vue?vue&type=template&id=b100a718&"
import script from "./btn-renderer.vue?vue&type=script&lang=js&"
export * from "./btn-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports